import { formatRecommendedAges } from '../helpers/helpers'

/** InfoWindow for map */
export function getInfoWindowLayout (place) {
  const link = `/places/${place.slug}`
  return `
    <div id="${place.name}" class="infowindow">
      <a href="${link}">
        <div class="infowindow-img-container">
          <img class="infowindow-img" src="${place.main_image || (place.images?.main?.url) || place.rating_category.thumbnail}" alt="${place.slug}">
          ${place.rating ? `<h1 class="item-rating">${Math.round(place.rating)}<span>/100</span></h1>` : ''}
        </div>
        <div class="infowindow-data">
          <div class="infowindow-data-first">
            <h2 class="infowindow-name">
            ${place.rating_category.logo ? `<img src="${place.rating_category.logo}" alt="${place.rating_category.meta_description}" width="18" height="18">` : ''}
              <span>${place.name}</span>
            </h2>
            <p class="infowindow-age">
              <span class="infowindow-icon"><i class="fas fa-child"></i></span>${formatRecommendedAges(JSON.parse(place.recommended_ages))}
            </p>
            <p class="infowindow-address">
              <span class="infowindow-icon"><i class="fas fa-map-marker-alt"></i></span>${place.address}, ${place.municipality}
            </p>
          </div>
          ${place.has_activities || place.external_booking ? '<div id="infowindow-book">Reserva</div>' : ''}
        </div>
      </a>
    </div>
    `
}
